export default "__VITE_ASSET__b2dadd94__"